var _controller;

function initDemande(controller) {
    initCarnetAdresses();

    _controller = controller;

    $("#btn-confirmer-demande").off('click').on("click", function (event) {
        event.preventDefault();
        validerDemande();
    });
}

/* Pour les formulaires Ajax : gestion du préloader */
function OnBeginSubmitForm() {
    $('#preloader').show();
    $('.form-alert-box').css('opacity', 0);
}

function OnCompleteSubmitForm() {
    $('#preloader').hide();
    $('.form-alert-box').css('opacity', 1);
}

OnSuccessModifierAdresse = function (data) {
    if (data.IsValid) {
        updateAdresse();
        cacherFormulaireAdresse();
    }
    else {
        afficherFormulaireAdresse(data.Html);
    }
}

function updateAdresse() {
    $.ajax({
        url: '/' + _controller + '/GetAdresse',
        data: {},
        success: function (result) {
            $('.adresse-list-item').html(result);
            initDemande(_controller);
        },
        beforeSend: function () {
            showPreloader();
        },
        complete: function () {
            hidePreloader();
        }
    });
}

function validerDemande() {
    $.ajax({
        url: '/' + _controller + '/SaveDemande',
        data: {},
        success: function (result) {
            $('.content-adresses').html(result);
            cacherFormulaireAdresse();

            tc_vars["page_name"] = "message_confirmation";
            $(document).foundation('common', 'refreshMasterTag');
        },
        beforeSend: function () {
            showPreloader();
        },
        complete: function () {
            hidePreloader();
        }
    });
}